var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._g({staticClass:"p-0 text-decoration-none font-weight-normal d-inline-flex align-items-center",attrs:{"to":_vm.to,"variant":"link","size":"sm"}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }